export const IconLoaderRedNormal: {
  name: 'icon_loader_red_normal-2ecf82cc5228'
} = {
  name: 'icon_loader_red_normal-2ecf82cc5228'
}
